<template>
	<BaseModal noPadding title="" v-model="model">
		<div class="-mt-8">
			<div class="flex flex-col items-center px-5">
				<LazyImage
					:src="GiftsIcon"
					alt="gifts"
					class="animate-hover-1 w-47.5"
				/>
				<div
					class="font-squad shadow-label animate-rotate mt-5 h-5 rounded-md bg-gradient-to-b from-[#FEC84B] to-[#FDB022] p-px text-xs font-black text-[#7A2E0E] uppercase"
				>
					<div
						class="flex h-4.5 items-center rounded-sm bg-[#FDB022] px-1.5 pt-0.5"
					>
						{{ t('welcome') }}
					</div>
				</div>
				<div
					class="font-squad text-label-primary mt-4 text-center text-2xl font-black uppercase"
				>
					{{ t('title') }}
				</div>
				<div class="text-label-secondary mt-2 text-sm">
					{{ t('desc') }}
				</div>
				<BenefitCard
					:primary="t('cases', 3)"
					:secondary="t('nextDeposit')"
					class="mt-6"
				>
					<BoxIcon />
				</BenefitCard>
				<BenefitCard
					:primary="t('bonus', [user.depositBonus])"
					:secondary="t('nextDeposit')"
					class="mt-1.5"
				>
					<GiftIcon />
				</BenefitCard>
				<!-- <div
					class="text-label-tertiary mt-6.5 flex items-center justify-center gap-2"
					v-if="user.invitedBy"
				>
					<UsersIcon class="h-5 w-5" />
					<div class="text-xs font-medium uppercase">
						{{ t('invitedBy', [user.invitedBy]) }}
					</div>
				</div> -->
			</div>
			<BottomActionsModal class="mt-5 pt-4">
				<RouterLink to="/onboarding" custom v-slot="{ navigate }">
					<BaseButton
						size="lg"
						color="primary"
						class="w-full"
						@click="closeAndNavigate(navigate)"
					>
						{{ t('continue') }}
					</BaseButton>
				</RouterLink>
			</BottomActionsModal>
		</div>
	</BaseModal>
</template>
<script setup lang="ts">
import { watch } from 'vue'
import BaseModal from './BaseModal.vue'
import BaseButton from '../BaseButton.vue'
import { useI18n } from 'vue-i18n'
import GiftsIcon from '@/assets/illustrations/gifts.png'
import LazyImage from '../LazyImage.vue'
import { useUser } from '@/stores/user'
import GiftIcon from '@/assets/icons/gift.svg'
import UsersIcon from '@/assets/icons/users.svg'
import BenefitCard from '../BenefitCard.vue'
import BottomActionsModal from '../BottomActionsModal.vue'
import BoxIcon from '@/assets/icons/box.svg'

const user = useUser()

// '0 гифтов выбрано | {n} гифт выбран | {n} гифта выбрано | {n} гифтов выбрано'

const { t } = useI18n({
	messages: {
		en: {
			welcome: 'welcome bonus',
			title: 'try rage.gift free',
			desc: `Don't sweat it... it's on the house.`,
			cases: '0 free cases | 1 free case | {n} free cases',
			bonus: '+{0}% bonus',
			nextDeposit: 'on your next deposit',
			invitedBy: 'invited by {0}',
			continue: 'continue'
		},
		ru: {
			welcome: 'приветственный бонус',
			title: 'попробуй rage.gift',
			desc: 'Не переживай... это за наш счет.',
			cases:
				'0 бесплатных кейсов | 1 бесплатный кейс | {n} бесплатных кейса | {n} бесплатных кейсов',
			bonus: '+{0}% бонус',
			nextDeposit: 'на следующее пополнение',
			invitedBy: 'пригласил {0}',
			continue: 'продолжить'
		}
	}
})

const emit = defineEmits<{
	(e: 'removeItem', uuid: string): void
}>()

const model = defineModel<boolean>()

const close = () => {
	model.value = false
}

const closeAndNavigate = (navigate: () => void) => {
	close()
	navigate()
}

watch(model, () => {
	if (model.value) {
		return
	}

	localStorage.setItem('activateModalShown', '1')
})
</script>
